import { cn } from '@/lib/utils';
import { getLandingHomeUrl } from '@/lib/landingUrl';

export interface PlatformCheckoutBrandProps {
  className?: string;
  /** `logo` — horizontal gradient mark; `icon` — square app icon. */
  variant?: 'logo' | 'icon';
}

export function PlatformCheckoutBrand({ className, variant = 'logo' }: PlatformCheckoutBrandProps) {
  const isLogo = variant === 'logo';

  return (
    <a
      href={getLandingHomeUrl()}
      className={cn(
        'flex w-fit items-center rounded-sm transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        isLogo ? 'gap-2' : 'gap-3',
        className
      )}
      aria-label="CourtSync home"
    >
      {isLogo ? (
        <img
          src="/logo-gradient.png"
          alt=""
          className="h-8 w-auto"
          width={126}
          height={32}
        />
      ) : (
        <img src="/icon.png" alt="" className="h-10 w-10" width={40} height={40} />
      )}
      <span className="text-xl font-bold text-gray-900 dark:text-white">CourtSync</span>
    </a>
  );
}
